import { InteractionRequiredAuthError, BrowserAuthError } from '@azure/msal-browser';

export const acquireToken = async (instance, accessTokenRequest) => {
  try {
    const response = await instance.acquireTokenSilent(accessTokenRequest);
    return response.accessToken;
  } catch (error) {
    if (
        error instanceof InteractionRequiredAuthError ||
        (error instanceof BrowserAuthError && error.errorCode === 'monitor_window_timeout')
    ) {
      instance.acquireTokenRedirect(accessTokenRequest);
    }
    throw error;
  }
};
